import { render, staticRenderFns } from "./cartoon.vue?vue&type=template&id=aba5a252&"
import script from "./cartoon.vue?vue&type=script&lang=ts&"
export * from "./cartoon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports